import UPEmptyState from 'components/empty-state';
import { MANAGEMENT__DOMAIN_EMPTY_STATE } from 'translations/constants';
import { ReactComponent as ClockIcon } from '../../assets/icons/ClockIcon.svg';

/**
 * Rendered for any configuration domain whose own story has not been delivered yet.
 *
 * Each domain story replaces this for its own domain by mounting a static child route under
 * /settings/management in AppRouter — a static segment outranks the `:domainKey/*` fallback.
 */
const DomainEmptyState = (): JSX.Element => (
  <UPEmptyState
    messageKey={MANAGEMENT__DOMAIN_EMPTY_STATE}
    icon={<ClockIcon />}
    testId="management-domain-empty-state"
  />
);

export default DomainEmptyState;
